import React from 'react';
import './Stage.css';
import useTypedSelector from '../../hooks/use-type-selectors';
import useActions from '../../hooks/use-actions';
import Timeline from '../Timeline/Timeline';
import { StageShape } from '../../models/Stage';
import { Units } from '../../models/Settings';
import StageCanvas, { StageCanvasMode } from '../StageCanvas/StageCanvas';
import MeasureInput from '../MeasureInput';
import { centimetersToFeetRounded, centimetersToMetersRounded } from '../../utils/general';

const Stage: React.FC = () => {
    const stage = useTypedSelector(state => state.undoable.stage);
    const settings = useTypedSelector(state => state.settings);
    const { setStageShape, setStageSize, setUnits } = useActions();

    function giveScreenReaderFeedback(text: string) {
        const feedbackBox = document.querySelector("#feedback");
        feedbackBox!.innerHTML = "";
        const textnode = document.createTextNode(text);
        feedbackBox?.appendChild(textnode);
    }

    function updateStageShape () {
        var element = (document.getElementById("stageShapeSelect")) as HTMLSelectElement;
        var opt = element.options[element.selectedIndex];
        
        switch(opt.value){
            case "rectangle": {
                setStageShape(StageShape.Rectangle);
                return;
            }
            case "oval": {
                setStageShape(StageShape.Oval);
                return;
            }
            default: return;
        }
    }

    function updateStageLength(length: number)
    {
        if (isNaN(length)) length = 0;
        let feedback = '';

        if (settings.units === Units.Metric) {
            feedback = 'stage length is ' + centimetersToMetersRounded(length) + ' meters';
        }
        else {
            feedback = 'stage length is ' + centimetersToFeetRounded(length) + ' feet';
        }

        giveScreenReaderFeedback(feedback);
        setStageSize({
            x: stage.size.x,
            y: length
        });
    }

    function updateStageWidth(width: number)
    {
        if (isNaN(width)) width = 0;
        let feedback = '';

        if(settings.units === Units.Metric) {
            feedback = 'stage width is ' + centimetersToMetersRounded(width) + ' meters';
        }
        else {
            feedback = 'stage width is ' + centimetersToFeetRounded(width) + ' feet';
        }

        giveScreenReaderFeedback(feedback);
        setStageSize({
            x: width,
            y: stage.size.y
        });
    }

    function updateMeasurementSystem(e: React.FormEvent<HTMLInputElement>)
    {
        if (e.currentTarget.value === "metric") {
            setUnits(Units.Metric);
        }
        else {
            setUnits(Units.Imperial);
        }

    }

    return (
        <div className='gridContainer'>
            <div className='sideBar'>
                <div style={{ display: 'flex', alignItems:'center', marginBottom: '20px' }}>
                    <img className='stageIcon' alt='stage' aria-hidden/>
                    <h1 style={{ margin: 0 }}>STAGE SHAPE & SIZE</h1>
                </div>
                <select id='stageShapeSelect' aria-label='stage shape is' className='dropdown' value={stage.shape} onChange={updateStageShape} >
                    <option value='rectangle'>Rectangle</option>
                    <option value='oval'>Oval</option>
                </select>
                <hr className='divider' aria-hidden />
                <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '20px', marginBottom: '20px' }}>
                    <div style={{ display: 'flex' }}>
                        <input aria-label="system is metric" className='toggleButton' type="radio" id="metric" name="system" value="metric" defaultChecked={settings.units === Units.Metric} onChange={updateMeasurementSystem}/><label htmlFor='metric' className='subtitle'>Metric</label>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <input aria-label="system is imperial" className='toggleButton' type="radio" id="imperial" name="system" value="imperial" defaultChecked={settings.units !== Units.Metric} onChange={updateMeasurementSystem}/><label htmlFor='imperial' className='subtitle'>Imperial</label>
                    </div>
                </div>
                <MeasureInput label='Length' value={stage.size.y} max={10000} onChangeFunc={updateStageLength} ariaLabel='stage length' />
                <MeasureInput label='Width' value={stage.size.x} max={10000} onChangeFunc={updateStageWidth} ariaLabel='stage width' />
            </div>
            <div className='stage'>
                <StageCanvas mode={StageCanvasMode.Stage}/>
            </div>
            <div className='timeline'>
                <Timeline />
            </div>
            
        </div>
    )
};

export default Stage;